import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type CardContentStylesClasses = 'container' | 'featureList' | 'featureItem';

const cardContentStyles = makeStyles<ISpcTheme, CardContentStylesClasses>(
  () => ({
    container: {
      padding: '0 20px',
    },
    featureList: {
      display: 'grid',
      gridGap: '10px',
    },
    featureItem: {
      position: 'relative',
    },
  }),
  { name: 'StockLite_CardContent' },
);

export default cardContentStyles;
